import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { watch, onMounted, ref } from 'vue'
import APIRequest from './api'
import { storeToRefs } from 'pinia'
import { useSetThemeType } from '@/utils/theme'
import { useSystemStore, initThemeFromCache, loadTheme } from '@/stores/system'
import { useUsersStore } from '@/stores/users'
import { isFeishu, useFeishuLogin, feishuJump, processFeishuData } from '@/utils/feishu'
import { RouteLocationNormalized, useRoute } from 'vue-router'
import { isApp, appLogin, hideNativeLoading } from './utils/client'
import TaskSwitch from '@/components/TaskSwitch.vue'
import BackIndexsuspendBall from '@/components/BackIndexsuspendBall.vue'
import { useTaskStore } from '@/stores/task'
import { useI18n } from 'vue-i18n'
import { setTitle } from '@/utils/platform'
import { isTudoApp, tuduLogin } from './utils/tudo'
import { isOutFieldApp, outFieldLogin } from './utils/outfield'
import { isSandsTalkFlutterApp, sandsTalkFlutterLogin } from './utils/sandsTalkFlutter'
import { sandsTalkPhOutfieldLogin, isSandsTalkPhOutfieldApp } from './utils/sandsTalkPhOutfiled'
import {
  isSandsTalkNativeApp,
  registerPreviousH5,
  sandsTalkNativeLogin,
  sandsTalkVnNativeLogin,
  registerVnPrevious
} from './utils/sandsTalkNative'
import Error from '@/components/Error.vue'
import Wxsdk from '@/utils/weixin'
import { useValidateToken } from '@/hooks/useValidateToken'
import { useAuthStore } from '@/stores/login'
import router from '@/router'
import { showToast } from 'vant'
import { isSandsTalkMiddleEastApp, sandsTalkMiddleEastOutfieldLogin } from './utils/sandsTalkMEOutfiled'
import { isSandsTalkBrMexApp, sandsTalkBrMexOutfieldLogin } from './utils/sandsTalkBRMXOutfiled'
import { branchManagerLogin, isBranchManagerApp } from './utils/sandsTalkBranchManager'
import { isWisdomRabbitApp, wisdomRabbitLogin } from './utils/sandsTalkSmartRabbit'
import { useSurveyChannel } from '@/hooks/useSurveyChannel'
import {
  cnDriverAutoLogin,
  isCnDriverAppSource,
  joinSandsTalkDriver,
  registerDriverPreviousH5
} from '@/utils/sandsTalkCnDriverApp'
import { isSandsTalkMSFlutterApp, sandsTalkMSFlutterLogin } from './utils/sandsTalkMSFlutter'
import { cnRabbitAssetInvLogin, isCnRabbitAppAssetInv } from '@/utils/sandsTalkAssetInv'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const system = useSystemStore()

watch(
  () => route.path,
  () => {
    system.checkAndRestoreLanguage()
  }
)

const { cachePageList } = storeToRefs(system)
const { resetCachePageList } = system
const validateShow = useValidateToken()
const taskStore = useTaskStore()
const { showTaskSwitch } = storeToRefs(taskStore)
const { setAppId, setJumpName } = useAuthStore()
const SandsTalkUserInfo = JSON.parse(localStorage.getItem('SandsTalkUserInfo') || '{}')

const showGlobalError = ref(false)
const globalErrorStatus = ref({
  info: '',
  imgSrc: 'error.png',
  showRetry: true,
  retryText: '重试'
})

const handleGlobalRetry = () => {
  showGlobalError.value = false
  window.location.reload()
}

const onGlobalRateLimited = () => {
  // 登录相关页面不显示全局限流遮罩
  const loginPaths = ['/login', '/enterpriseLogin', '/phoneLogin', '/multiAccount']
  const isLoginPage = loginPaths.some((path) => route.path.startsWith(path))

  if (isLoginPage) {
    showToast(t('当前使用人数过多,请稍后再试'))
    return
  }

  showGlobalError.value = true
  globalErrorStatus.value = {
    info: t('当前使用人数过多,请稍后再试'),
    imgSrc: 'error.png',
    showRetry: true,
    retryText: t('重试')
  }
}

const onTriggerGlobalError = (e) => {
  const { info, imgSrc, showRetry, retryText } = e.detail || {}
  showGlobalError.value = true
  globalErrorStatus.value = {
    info: info || t('app_network_error'),
    imgSrc: imgSrc || 'error.png',
    showRetry: showRetry !== false,
    retryText: retryText || t('重试')
  }
}

onMounted(() => {
  window.addEventListener('global_rate_limited', onGlobalRateLimited)
  window.addEventListener('trigger_global_error', onTriggerGlobalError)
})

// 先从缓存初始化
initThemeFromCache()
// 加载主题
loadTheme()

// 泰国外场 - 销毁页面
if (SandsTalkUserInfo.source === 'ThOutfield') {
  registerPreviousH5()
}

// 越南外场 - 销毁页面
if (window.jt || (!window.jt && window.flutter_inappwebview)) {
  registerVnPrevious()
}

// 司机销毁页面
if (isCnDriverAppSource()) {
  registerDriverPreviousH5()
}

// 路由动态缓存
router.beforeEach((to, from, next) => {
  // console.log(from.name, 'from.name111111111111111==============', to.name, cachePageList.value)
  // 如果从二级页面进入三级页面此时会缓存二级页面，二级页面在路由中的定义pageLevel:2,三级页面pageLevel:3
  // 也可以以此扩展，可以有四级页面level累加就行，如果要页面动态缓存要保证它接下来的页面是当前页面的level+1。才可以进行动态缓存
  // 需要注意的点:
  // 1.页面缓存生效需要在页面指定name，并且跟路由name保持一致
  // 2.如果存在页面被共用，并且level还不一样，那么这个方法不适用，只能在页面处理动态缓存
  if (to.path === '/shopIndexTab') {
    resetCachePageList()
  }
  if (from?.meta?.isKeepAlive) {
    if (!isExistCache(from)) {
      cachePageList.value.push(from.name as string)
    }
    if (to.path === '/my') {
      // 如果跳到我的页面，则初始化缓存
      resetCachePageList()
    }
    // 直播详情回来的时候，需要清除缓存

    if (
      from.name === 'TeachManageLive' &&
      cachePageList.value.includes('TeachManageLive') &&
      ['MyTeachManage', 'TeachManagementList'].includes(to.name as string)
    ) {
      const indexToRemove = cachePageList.value.indexOf('TeachManageLive')
      if (indexToRemove !== -1) {
        cachePageList.value.splice(indexToRemove, 1)
      }
    }
  } else {
    // 讲师页面用的太多，提到最外面
    // const indexToRemove = cachePageList.value.indexOf('lecturerDetail')
    // if (indexToRemove !== -1) {
    //   cachePageList.value.splice(indexToRemove, 1)
    // }
    if (to?.meta?.pageLevel && from?.meta?.pageLevel && Number(from.meta.pageLevel) + 1 === Number(to.meta.pageLevel)) {
      if (!isExistCache(from)) {
        cachePageList.value.push(from.name as string)
      }
    } else {
      // console.log('清除缓存11111111111====================', from.name, cachePageList.value)
      // 其他情况清除缓存
      if (isExistCache(from)) {
        cachePageList.value.forEach((e: string, i) => {
          if (e === from.name) {
            cachePageList.value.splice(i, 1)
          }
        })
      } else if (from.name === 'courseDetail' && to.name === 'course') {
        cachePageList.value.forEach((e: string, i) => {
          if (e === 'lecturerDetail') {
            cachePageList.value.splice(i, 1)
          }
        })
      } else if (from.name === 'faceDetail' || from.name === 'teamStudyDetail') {
        const indexToRemove = cachePageList.value.indexOf('lecturerDetail')
        if (indexToRemove !== -1) {
          cachePageList.value.splice(indexToRemove, 1)
        }
      }
    }
  }
  console.log('cachePageList.value', cachePageList.value)
  next()
})

const isExistCache = (from: RouteLocationNormalized) => {
  return cachePageList.value.length > 0 && cachePageList.value.filter((e: string) => e === from.name).length > 0
}

const completed = ref(false)
// const getSandsTalkToken = localStorage.getItem('sandsTalkToken')
onMounted(async () => {
  if (isApp) {
    appLogin({
      callback() {
        hideNativeLoading()
        completed.value = true
      }
    })
  } else if (isTudoApp) {
    await tuduLogin()
    completed.value = true
  } else if (isSandsTalkFlutterApp) {
    await sandsTalkFlutterLogin()
    completed.value = true
  } else if (isSandsTalkMSFlutterApp) {
    // 马来兔学堂
    await sandsTalkMSFlutterLogin()
    completed.value = true
  } else if (isOutFieldApp) {
    // 外场
    await outFieldLogin()
    completed.value = true
  } else if (isSandsTalkPhOutfieldApp) {
    // 菲律宾外场
    sandsTalkPhOutfieldLogin().then((success) => {
      completed.value = success
    })
  } else if (isSandsTalkMiddleEastApp) {
    // 中东外场
    await sandsTalkMiddleEastOutfieldLogin()
    completed.value = true
  } else if (isSandsTalkBrMexApp) {
    // 巴西、墨西哥外场
    await sandsTalkBrMexOutfieldLogin()
    completed.value = true
  } else if (isSandsTalkNativeApp) {
    if (window.jt || (!window.jt && window.flutter_inappwebview)) {
      // 越南外场
      await sandsTalkVnNativeLogin()
    } else {
      // 泰国外场
      await sandsTalkNativeLogin()
    }
    completed.value = true
  } else if (isBranchManagerApp) {
    // 网点管家
    await branchManagerLogin()
    completed.value = true
  } else if (isWisdomRabbitApp) {
    // 智兔App
    await wisdomRabbitLogin()
    completed.value = true
  } else if (isCnDriverAppSource()) {
    // cn_driver_app 免登优先处理
    await joinSandsTalkDriver()
    await cnDriverAutoLogin()
    completed.value = true
    return
  } else if (isCnRabbitAppAssetInv()) {
    // 中国智兔 资产管理 免登
    await cnRabbitAssetInvLogin()
    completed.value = true
    return
  } else if (isFeishu) {
    if (window.location.hostname.includes('saas')) {
      // 优先从 URL 查询参数中提取 tenant-id（兼容 search 与 hash）
      const tenantFromUrl = (() => {
        try {
          const u = new URL(window.location.href)
          let v = u.searchParams.get('tenant-id')
          if (!v && u.hash) {
            const hash = u.hash
            const qIndex = hash.indexOf('?')
            if (qIndex !== -1) {
              const hashSearch = new URLSearchParams(hash.substring(qIndex + 1))
              v = hashSearch.get('tenant-id') || v
            }
          }
          return v
        } catch {
          return null
        }
      })()
      if (tenantFromUrl) {
        localStorage.setItem('feishuTenantId', tenantFromUrl)
      } else {
        if (!isFeishu) {
          router.replace({
            path: '/login'
          })
        }
      }
    }

    // 增加 token 判断
    useFeishuLogin({
      callback() {
        completed.value = true
      },
      onError() {
        completed.value = true
      }
    })
  } else {
    completed.value = true
  }

  window.Wxsdk = new Wxsdk()
})

const setThemeType = useSetThemeType()
const usersStore = useUsersStore()
const { collegeId } = storeToRefs(usersStore)
watch(
  [collegeId, completed],
  async () => {
    if (!localStorage.getItem('sandsTalkToken')) {
      return
    }
    if (!completed.value) {
      return
    }
    const { code, data, status } = await APIRequest.App.getAppSkin()
    if (code === 1) {
      setThemeType(data.themeColorType)
    } else if (status === 429) {
      setThemeType(0)
    }
  },
  {
    immediate: true
  }
)

watch(
  [showTaskSwitch.value, route],
  () => {
    if (isFeishu) {
      setAppId('')
      setJumpName('')
      processFeishuData(setAppId, feishuJump, setJumpName)
    }
    if (showTaskSwitch.value && !route.query?.trainingId) {
      taskStore.setShowTaskSwitch(false)
    }
  },
  {
    immediate: true
  }
)

const languageCompleted = ref(false)
const systemStore = useSystemStore()
const { getAppSupportLanguage } = systemStore
const { langsJson } = storeToRefs(systemStore)
const { isAllowedChannel } = useSurveyChannel()

if (isAllowedChannel(route.query.channel as string)) {
  systemStore.initializeLanguage()
  languageCompleted.value = true
} else {
  getAppSupportLanguage(() => {
    systemStore.initializeLanguage()
    // const date = new Date().getTime()
    // console.log('languageCompleted:' + date)
    // console.log('languageCompleted-appLaunch:' + (date - window.appLaunch))
    languageCompleted.value = true
  })
}

watch([langsJson], () => {
  setTitle(t((route.meta.title || '') as string))
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (completed.value && languageCompleted.value && _unref(validateShow))
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_KeepAlive, {
              include: _unref(cachePageList),
              exclude: []
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: (_unref(route).name as string)
              }))
            ], 1032, ["include"]))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showGlobalError.value)
      ? (_openBlock(), _createBlock(Error, {
          key: 1,
          status: globalErrorStatus.value,
          selfStyle: { height: '100vh', position: 'fixed', top: 0, left: 0, zIndex: 9999 },
          onRetry: handleGlobalRetry
        }, null, 8, ["status"]))
      : _createCommentVNode("", true),
    _createVNode(TaskSwitch),
    _createVNode(BackIndexsuspendBall)
  ], 64))
}
}

})